export const validateValue = (value, regex = null) => {
    if (value.trim() === "") { return true; }
    // If regex is provided, test the value against the regex
    if (regex && !regex.test(value)) { return true; }
    // If all checks pass
    return false;
};

export const initialDate = (newDate) => {
    let date = new Date();
    if (newDate) { date = new Date(newDate); }
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let year = date.getFullYear();
    return `${year}-${month}-${day}`;
}

export const isFormValid = (errors) => {
  return !Object.values(errors).some(error => error === true);
};
